<template>
  <div class="dynamic">
    <div class="w">
      <!-- 边框 -->

      <div class="left_list">
        <div class="inner_blocks">
          <div class="art_topics">
            <span class="ar_right"
              ><div class="top_title">
                {{ xq.title }}
              </div>
              <div class="ar_details">
                <span class="check_list">{{
                  xq.create_time
                }}</span>
              </div></span
            >
          </div>
          <div class="wrap_content">
            <div class="rich_media_content" id="js_content">
              <!-- 文字 -->
              <section
                data-tools="135编辑器"
                data-id="102962"
                style="
                  max-width: 100%;
                  font-family: -apple-system, BlinkMacSystemFont,
                    'Helvetica Neue', 'PingFang SC', 'Hiragino Sans GB',
                    'Microsoft YaHei UI', 'Microsoft YaHei', Arial, sans-serif;
                  letter-spacing: 0.544px;
                  white-space: normal;
                  background-color: rgb(255, 255, 255);
                  box-sizing: border-box !important;
                  word-wrap: break-word !important;
                "
              >
                <section
                  style="
                    margin: 10px auto;
                    max-width: 100%;
                    text-align: center;
                    box-sizing: border-box !important;
                    word-wrap: break-word !important;
                  "
                >
                  <section
                    style="
                      margin-top: -10px;
                      max-width: 100%;
                      box-sizing: border-box;
                      border-width: 6px;
                      border-style: solid;
                      border-color: rgb(141, 179, 226);
                      word-wrap: break-word !important;
                    "
                  >
                    <section
                      style="
                        max-width: 100%;
                        background-image: url('https://doctor-filemanager.oss-cn-beijing.aliyuncs.com/mp/202104/20210424084542248936.png');
                        background-position: 0% 0%;
                        background-size: 100%;
                        background-repeat: repeat;
                        background-attachment: initial;
                        background-origin: initial;
                        background-clip: initial;
                        transform: rotate(0deg);
                        box-sizing: border-box !important;
                        word-wrap: break-word !important;
                      "
                    >
                      <section
                        style="
                          padding: 1em;
                          max-width: 100%;
                          box-sizing: border-box;
                          word-wrap: break-word !important;
                        "
                      >
                        <section
                          data-autoskip="1"
                          style="
                            max-width: 100%;
                            text-align: justify;
                            line-height: 1.75em;
                            letter-spacing: 1.5px;
                            font-size: 14px;
                            color: rgb(11, 102, 217);
                            background: transparent;
                            box-sizing: border-box !important;
                            word-wrap: break-word !important;
                          "
                        >
                      
                          <p
                            style="
                              max-width: 100%;
                              min-height: 1em;
                              line-height: 2em;
                              box-sizing: border-box !important;
                              word-wrap: break-word !important;
                            "
                          >
                            <span
                              style="
                                max-width: 100%;
                                color: rgb(62, 62, 62);
                                font-size: 14px;
                                box-sizing: border-box !important;
                                word-wrap: break-word !important;
                              "
                              v-html="xq.content"
                            >
                            </span>
                          </p>
                        </section>
                      </section>
                    </section>
                  </section>
                </section>
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Bottom } from "@/common/js/api";
 
import { urlImg } from "@/common/js/url";
export default {
  name: "DynamicNei",
  data() {
    return {
      ID: "",
      xq: {},
    };
  },
  
  created() {
    this.urlImg = urlImg();
    this.ID = this.$route.query.id;
    this.Bottom();
  },
  methods: {
    //   政策详情
    Bottom(id) {
      Bottom({
       })
        .then((res) => {
          console.log(res);
         
          // this.xq.level = this.xq.leveltype.name;
          for (let i = 0; i <  res.data.length; i++) {
              if (res.data[i].id ==  this.ID) {
                   this.xq = res.data[i];
              }
              
          }
        })
        .catch(() => {});
    },
  },

  mounted() {},
};
</script>

<style scoped lang="less">
.left_list {
  margin-top: 30px;
  padding: 12px 225px 20px;
}
.art_topics .ar_right .top_title {
  color: #4d4d4d;
  font-weight: 700;
  font-size: 28px;
  line-height: 1.2;
  text-align: center;
}
.art_topics .ar_right .ar_details {
  margin: 16px 0;
  text-align: center;
  color: rgba(105, 105, 105, 100);
}
.img {
  // // width: 609px;
  // height: 228px;
  height: auto;
  // width: auto;
}
</style>